<template>
  <div>
    

  <div class="row pad">
    
      <div class="col s12 m8m">


        <div class="row">
          <div class="col s4 m2"><img src="https://nl.biomedia.net/nlweb/images/sip/head2013.png" style="height:70px;"/></div>
          <div class="col s8 m10"><h2>{{$socio.contatto.row.cognome}} {{$socio.contatto.row.nome}}</h2> </div>
        </div>


        <div class="row pad-in" v-for="(itm, index)  in $socio._si"  :key="index" :class="'item_'+itm.id" v-if="itm.dimesso!=1 && itm.societa!=169" style ="margin-top:20px;">
          <div class="col s1m yo-align-left yo-valign-text-center" style="height:50px;">{{itm.societa | items($teras._societa,'sigla')}}</div>
          <div class="col s4 yo-valign-text-center" style="height:50px;">{{itm.societa | items($teras._societa,'nome')}}</div>
          <div class="col s2m yo-valign-text-center yo-align-right" style="height:50px;" v-if="itm.dimesso==0">in regola al {{itm.ultimoanno}}</div>
          <div class="col s2m yo-valign-text-center yo-align-right" style="height:50px;" v-if="itm.societa==169 && itm.dimesso==0">anno {{itm.ultimoanno}}</div>
         <div class="col s2m yo-valign-text-center yo-align-right" style="height:50px;" v-if="itm.dimesso==1">dimesso</div>
        </div> 

        <div class="row pad-in" v-for="(itm, index)  in $socio._si"  :key="index" :class="'item_'+itm.id" v-if="itm.ultimoanno>$moment().format('YYYY')-1 && itm.societa==169" style ="margin-top:20px;">
          <div class="col s1m yo-align-left yo-valign-text-center" style="height:50px;">{{itm.societa | items($teras._societa,'sigla')}}</div>
          <div class="col s4 yo-valign-text-center" style="height:50px;">{{itm.societa | items($teras._societa,'nome')}}</div>
          <div class="col s2m yo-valign-text-center yo-align-right" style="height:50px;" v-if="itm.dimesso==0">in regola al {{itm.ultimoanno}}</div>
        </div>



    <el-collapse v-if="false">
  
  <!--
  <el-collapse-item name="societa">
    <template slot="title">
      <div class="row">
        <div class="col s8">SIP  </div>
        <div class="col s3m yo-align-right">in regola al {{$socio.si.row.ultimoanno}}</div>
      </div>
    </template>
      <siHome :item="$socio.si.row" ></siHome>
  </el-collapse-item>
-->


  <el-collapse-item  v-for="(itm, index) in $socio._si" :item="itm" v-bind:key="index" :name="itm.societa">
    <template slot="title">
      <div class="row">
        <div class="col s8">{{itm.societa | items($teras._societa,'sigla')}} - {{itm.societa | items($teras._societa,'nome')}}</div>
        <div class="col s3m yo-align-right">in regola al {{itm.ultimoanno}}</div>
      </div>
    </template>
      <siHome :item="itm" ></siHome>
  </el-collapse-item>
  






  <el-collapse-item name="versamenti" v-if="false">
    <template slot="title">
      <div class="row">
        <div class="col s8">Versamenti</div>
        <div class="col s3m yo-align-right" v-if="this.$socio._versamento.length>0">ultimo effetuato il {{$socio._versamento[0].inseritoil | data()}} di {{$socio._versamento[0].importo | money('€ ')}}</div>
      </div>
    </template>

    <versamento></versamento>

  </el-collapse-item>



</el-collapse>



        <div class="row pad" style="margin-top:30px;" v-if="$teras.app.device!='mobile'">
          <!--
            <div class="col s12 m4 yo-bg-color-secondary yo-align-center" style="padding-top:10px;padding-bottom:10px;"><router-link to="/contatto-edit" class="white">PROFILO</router-link></div>
          <div class="col s12 m4 yo-bg-color-secondary yo-align-center" style="padding-top:10px;padding-bottom:10px;"><router-link to="/contatto-password" class="white">CREDENZIALI</router-link></div>
          -->
          <div class="col s12 m6 offset-m6 yo-bg-color-secondary yo-align-center" style="padding-top:10px;padding-bottom:10px;"><router-link to="/contatto-rinnovo" class="white">RINNOVO E NUOVE ADESIONI</router-link></div> 
        </div>
<br />
<hr />
<br />

        <h2>Assicurazione</h2> 

Ti ricordiamo che per poter aderire alla polizza RC Professionale sottoscritta da SIP dovrai preventivamente essere in regola con la quota sociale 2024.
<br />

    <!-- rimossa per anno 2020 su richiesta di ELisabetta con tkt 684315
    <div class="row pad" style="margin-top:30px;">        
      <div class="col s12 m6 offset-m6 yo-bg-color-secondary yo-align-center" style="padding-top:10px;padding-bottom:10px;"><a :href="url+tokenURI" target="_blank" class="white">VAI ALLA POLIZZA ASSICURATIVA ({{$socio.contatto.row.id}})</a></div>
    </div>
    -->
    <!--
      <div class="col s12">{{token}}</div>
      <div class="col s12">{{tokenAES}}</div>
    -->
    <!--
    <div class="row pad" style="margin-top:30px;" v-if="$socio.contatto.row.id==3260 || $socio.contatto.row.id==1">
      <div class="col s12 m6 offset-m6 yo-bg-color-secondary yo-align-center" style="padding-top:10px;padding-bottom:10px;"><a :href="demo_url+demo_tokenURI" target="_blank" class="white">VAI ALLA POLIZZA ASSICURATIVA DEMO</a></div>
    </div>
    -->




          <assicurazione v-if="this.$socio._assicurazione.length>0"></assicurazione>



<br />
<hr />
<br />
<!--
        <h2>Le società affiliate</h2> 
        A breve saranno disponibili i link delle Tesorerie delle Società Affiliate SIP a cui risulta iscritto.
-->

      </div>

      <div class="col s12 m3m">
        <contattoSide></contattoSide>
      </div>

    </div>



</div>
</template>

<script>
import siHome from './Si-home.vue'
import contattoSide from './Contatto-side.vue'
import versamento from './Versamento.vue'
import assicurazione from './Assicurazionereport.vue'
import aes from '../teras/aes'
import demo_aes from '../teras/aes'

export default {
   name: 'home'
   ,components: {
    contattoSide
    ,siHome
    ,versamento
    ,assicurazione
  }
  ,data () {
    return {
      demo_key:'X40RFfFuZYckb2Vu',
      demo_codProd:'ME8METAPRODOTTOSIP',
      demo_idConv:'264643',
      demo_password:'',
      demo_url:'https://www.oneaffinitydemo.aon.it/en/web/ingegneri/landing-page?token=',

      key:'A8PjrsGNFz6GWDad',
      codProd:'ME2PROGRAMMAASSICURA',
      idConv:'323891',
      password:'',
      url:'https://www.sip.aon.it/landing-page?token='
    }
     



  }
  ,created () {

    if(this.$moment(this.$socio.si.row.authbasic).format('YYYY')<this.$moment().format('YYYY'))
      this.$router.push('/contatto-edit')



    //aes.password = aes.convertCryptKey(this.key)
  }
  ,mounted () {
    if(this.$socio.contatto.row.codicefiscale=='')
      this.$router.push('/contatto-edit')
    
  }
  ,computed: {
      token: function () {
         var params = []
        params.push('COD_PROD='+this.codProd)
        params.push('ID_CONV='+this.idConv)
        params.push('NOM_CON='+this.$socio.contatto.row.nome)
        params.push('COG_CON='+this.$socio.contatto.row.cognome)
        params.push('DAT_NAS_CON='+this.$teras.data(this.$socio.contatto.row.natoil,'DD-MM-YYYY'))
        params.push('EMAIL_CON='+this.$socio.contatto.row.email)
        params.push('NUM_TRAN='+this.$socio.contatto.row.id)
        params.push('DESCR_TRAN='+this.$socio.contatto.row.codicefiscale)

        return params.join('|')
      }
      ,tokenAES: function () {
        aes.password = demo_aes.convertCryptKey(this.key)
        return aes.encode64(this.token)
      }
      ,tokenURI: function (){
        return encodeURIComponent(this.tokenAES)
      }
      ,demo_token: function () {
         var params = []
        params.push('COD_PROD='+this.demo_codProd)
        params.push('ID_CONV='+this.demo_idConv)
        params.push('NOM_CON='+this.$socio.contatto.row.nome)
        params.push('COG_CON='+this.$socio.contatto.row.cognome)
        params.push('DAT_NAS_CON='+this.$teras.data(this.$socio.contatto.row.natoil,'DD-MM-YYYY'))
        params.push('EMAIL_CON='+this.$socio.contatto.row.email)
        params.push('NUM_TRAN='+this.$socio.contatto.row.id)
        params.push('DESCR_TRAN='+this.$socio.contatto.row.codicefiscale)

        return params.join('|')
      }
      ,demo_tokenAES: function () {
        //demo_aes.password = demo_aes.convertCryptKey(this.demo_key)
        return demo_aes.encode64(this.demo_token)
      }
      ,demo_tokenURI: function (){
        return encodeURIComponent(this.demo_tokenAES)
      }
   }
   
}
</script>
